/* eslint-disable react/prop-types */ //
import { Feature, Point } from "geojson";
import { memo } from "react";

import { DealershipsFeaturesProps, DealsFeaturesProps } from "../types";

type SingleFeatureInfoWindowContentProps = {
  feature: Feature<Point>;
};
type DealInfoWindowContentProps = {
  features: Feature<Point>[];
};
const numFmt = new Intl.NumberFormat();

export const DealInfoWindowContent = memo(
  ({ features }: DealInfoWindowContentProps) => {
    if (features.length === 1) {
      const f = features[0];
      const props = { ...f.properties } as unknown as DealsFeaturesProps;

      return (
        <div>
          <h3 style={{ textAlign: "center" }}>Deal Info</h3>
          <p>
            <strong>Applicant:</strong> {props?.applicantNames || "N/A"}
          </p>
          <p>
            <strong>Dealership:</strong> {props?.dealershipName ?? "N/A"}
          </p>

          <p>
            <strong>Collateral:</strong>{" "}
            {(
              props?.vehicle?.year +
              " " +
              props?.vehicle?.make +
              " " +
              props?.vehicle?.model
            ).trim() ?? "N/A"}
          </p>
          <p>
            <strong>Amount Financed:</strong> $
            {props?.amountFinanced?.toFixed(2) || 0}
          </p>
        </div>
      );
    }

    return (
      <div>
        <h4>{numFmt.format(features.length)} deals. Zoom in to explore.</h4>
      </div>
    );
  },
);

export const DealershipInfoWindowContent = memo(
  ({ feature }: SingleFeatureInfoWindowContentProps) => {
    const props = feature.properties as DealershipsFeaturesProps;
    return (
      <div>
        <div>
          <p>
            <strong>Name:</strong> {props?.name}
          </p>
        </div>
      </div>
    );
  },
);
